<div class="error-page">
  <jtm-navigation-J4></jtm-navigation-J4>

  <div class="error-container">
    <div class="error-title">Something went wrong</div>
    <br />
    <br />
    @if (displayNoAccessToTenantError) {
      <div class="error-msg">User doesn't have access to the tenant.</div>
    }
  </div>
</div>
